import '.au{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.hv{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.ar{align-items:flex-start;}.ssr-plugin'
import '.d2{padding:2rem;}.ssr-plugin'
import '.dq{background:var(--palette-white);}.ssr-plugin'
import '.b1{overflow:hidden;}.ssr-plugin'
import '.br{position:absolute;}.ssr-plugin'
import '.jq{top:50%;}.ssr-plugin'
import '.jr{right:1rem;}.ssr-plugin'
import '.js{transform:translateY(-50%);}.ssr-plugin'
import '.jt{width:120px;}.ssr-plugin'
import '.ju{height:120px;}.ssr-plugin'
import '.jv{z-index:0;}.ssr-plugin'
import '.z{align-items:center;}.ssr-plugin'
import '.j5{z-index:1;}.ssr-plugin'
import '.a0{gap:0.5rem;}.ssr-plugin'
import '.jw{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jx{font-size:4rem;}.ssr-plugin'
import '.dk{font-weight:700;}.ssr-plugin'
import '.jy{line-height:100%;}.ssr-plugin'
import '.gy{margin:0px;}.ssr-plugin'
import '.q{color:var(--brand-secondary);}.ssr-plugin'
import '.r{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="au n hv d e ad ar d2 dq b1"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="br jq jr js jt ju jv d z ad"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="au j5 d e ar a0 jw"
      >
        <div className="jx dk jy gy q r"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
